var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" "+_vm._s(_vm.getMod)+" "),_c('button',{on:{"click":_vm.changeStr}},[_vm._v("chg")]),_c('br'),_c('c-anoth')],1)}
var staticRenderFns = []

export { render, staticRenderFns }